import * as z from "zod/v4";

export const getMessagingConversationDetail = {
  name: "getMessagingConversationDetail" as const,
  input: z.object({
    conversationId: z.string(),
    source: z.enum(["mobile_message", "marketing"]),
  }),
  output: z.object({
    conversation: z.object({
      id: z.string(),
      source: z.enum(["mobile_message", "marketing"]),
      conversationType: z.enum(["pre_purchase", "post_purchase"]),
      customerName: z.string().nullable(),
      customerPhone: z.string().nullable(),
      customerEmail: z.string().nullable(),
      lastMessagePreview: z.string().nullable(),
      lastMessageAt: z.string().nullable(),
      status: z.enum(["open", "closed", "snoozed"]),
      channel: z.enum(["imessage", "sms", "email"]),
      skillId: z.string().nullable(),
      aiDisabled: z.boolean(),
    }),
    messages: z.array(
      z.object({
        id: z.string(),
        senderType: z.enum(["customer", "ai", "merchant", "system"]),
        content: z.string(),
        channel: z.string(),
        sentAt: z.string().nullable(),
      }),
    ),
    customer: z
      .object({
        name: z.string().nullable(),
        email: z.string().nullable(),
        phone: z.string().nullable(),
      })
      .nullable(),
    activeSkillId: z.string().nullable(),
  }),
};
